import React, { createContext, useState } from 'react';
import AppStorage from 'AppStorage';
import {
  PolicyPayload,
  PolicyFrequency,
  PaymentFreq,
  MultiQuotePayload,
  DocumentUploadFlag,
  DocumentUploadedPayload,
  PromoCodePayload,
  PromoCodeSummaryPayload,
  OriginalPremiumPlanPayload,
  DeductiblePayload,
  UnderwriteMeStaticAnswersPayload,
  ApplicationPolicyPayload,
  DonationPayload,
  // ToastNotificationPayload,
  UnderwriteMeValidationPayload,
  PolicyRefNoPayload,
  EPFCampaignCodePayload
} from 'Constants';
import PropTypes from 'prop-types';

export const PolicyPayloadContext = createContext({});

const PolicyPayloadProvider = ({ children }) => {
  const getPolicyPayload = () => {
    const _payload = AppStorage.getItem(PolicyPayload);
    if (_payload) {
      // const parsedPayload = JSON.parse(_payload);
      // return parsedPayload;
      return _payload;
    }
    return null;
  };

  const getPaymentFrequency = () => {
    const _frequency = AppStorage.getItem(PolicyFrequency);
    return _frequency;
  };

  const getOriginalPremiumPlan = () => {
    return AppStorage.getItem(OriginalPremiumPlanPayload) || [];
  };

  const getIsDocumentUploaded = () => {
    const _uploadFlag = AppStorage.getItem(DocumentUploadFlag);
    return _uploadFlag || null;
  };

  const geDocumentUploaded = () => {
    const _files = AppStorage.getItem(DocumentUploadedPayload);
    return _files || [];
  };

  const getMultiQuotes = () => {
    const _payload = AppStorage.getItem(MultiQuotePayload);
    if (_payload) {
      // const parsedPayload = JSON.parse(_payload);
      // return parsedPayload;
      return _payload;
    }
    return null;
  };

  const getPromoCode = () => {
    const _payload = AppStorage.getItem(PromoCodePayload);
    return _payload || null;
  };

  const getPromoCodeSummary = () => {
    const _payload = AppStorage.getItem(PromoCodeSummaryPayload);
    return _payload || null;
  };

  const getDeductiblePayload = () => {
    const _payload = AppStorage.getItem(DeductiblePayload);
    return _payload || null;
  };

  const getUnderwriteMeStaticAnswersPayload = () => {
    return AppStorage.getItem(UnderwriteMeStaticAnswersPayload) || [];
  };

  const getUnderwriteMeValidationPayload = () => {
    return AppStorage.getItem(UnderwriteMeValidationPayload) || [];
  };
  const getApplicationPolicyPayload = () => {
    return AppStorage.getItem(ApplicationPolicyPayload) || [];
  };

  const getDonationPayload = () => {
    return AppStorage.getItem(DonationPayload) || {};
  };

  const getPolicyRefNoPayload = () => {
    return AppStorage.getItem(PolicyRefNoPayload) || null;
  };

  const getEPFCampaignCodePayload = () => {
    return AppStorage.getItem(EPFCampaignCodePayload) || null;
  };

  const [policyPayload, setPayload] = useState(getPolicyPayload());

  const [paymentFrequency, setPayFrequency] = useState(getPaymentFrequency());
  const [originalPremiumPlanPayload, setOriginalPremiumPlanPayload] = useState(
    getOriginalPremiumPlan()
  );

  const [multiQuotes, setMultiQuotesPayload] = useState(getMultiQuotes());

  const [isDocumentUploaded, setDocumentUploadFlag] = useState(getIsDocumentUploaded());

  const [documentUploadedPayload, setDocumentUploadedPayload] = useState(geDocumentUploaded());

  const [promoCodePayload, setPromoCode] = useState(getPromoCode());
  const [promoCodeSummaryPayload, setPromoCodeSummaryPayload] = useState(getPromoCodeSummary());
  const [deductiblePayload, setDeductible] = useState(getDeductiblePayload());

  const [underwriteMeStaticAnswersPayload, setUnderwriteMeStaticAnswers] = useState(
    getUnderwriteMeStaticAnswersPayload()
  );

  const [underwriteMeValidationPayload, setUnderwriteMeValidation] = useState(
    getUnderwriteMeValidationPayload()
  );

  const [applicationPolicyPayload, setApplicationPayload] = useState(getApplicationPolicyPayload());

  const [donationPayload, setDonation] = useState(getDonationPayload());

  const [policyRefNoPayload, setPolicyRefNo] = useState(getPolicyRefNoPayload());

  const [ePFCampaignCodePayload, setEPFCampaignCode] = useState(getEPFCampaignCodePayload());

  const setPolicyPayload = (_payload) => {
    AppStorage.setItem(PolicyPayload, _payload);
    setPayload(_payload);
  };

  const clearPayload = (_initialMultiQuote) => {
    AppStorage.removeItem(PolicyPayload);
    AppStorage.removeItem(PromoCodePayload);
    setPaymentFrequency(PaymentFreq.monthly);
    setMultiQuotes(_initialMultiQuote);
  };

  const setPaymentFrequency = (_frequency) => {
    AppStorage.setItem(PolicyFrequency, _frequency);
    setPayFrequency(_frequency);
  };

  const setOriginalPremiumPlan = (_plans) => {
    AppStorage.setItem(OriginalPremiumPlanPayload, _plans);
    setOriginalPremiumPlanPayload(_plans);
  };

  const setMultiQuotes = (_payload) => {
    AppStorage.setItem(MultiQuotePayload, _payload);
    setMultiQuotesPayload(_payload);
  };

  const setIsDocumentUploaded = (_uploadFlag) => {
    AppStorage.setItem(DocumentUploadFlag, _uploadFlag);
    setDocumentUploadFlag(_uploadFlag);
  };

  const setDocumentUploaded = (_document) => {
    AppStorage.setItem(DocumentUploadedPayload, _document);
    setDocumentUploadedPayload(_document);
  };

  const setPromoCodePayload = (_promoCodeDetails) => {
    AppStorage.setItem(PromoCodePayload, _promoCodeDetails);
    setPromoCode(_promoCodeDetails);
  };

  const setPromoCodeSummary = (payload) => {
    AppStorage.setItem(PromoCodeSummaryPayload, payload);
    setPromoCodeSummaryPayload(payload);
  };

  const setDeductiblePayload = (_deductible) => {
    AppStorage.setItem(DeductiblePayload, _deductible);
    setDeductible(_deductible);
  };

  const setUnderwriteMeStaticAnswersPayload = (_answers) => {
    AppStorage.setItem(UnderwriteMeStaticAnswersPayload, _answers);
    setUnderwriteMeStaticAnswers(_answers);
  };

  const setUnderwriteMeValidationPayload = (_payload) => {
    AppStorage.setItem(UnderwriteMeValidationPayload, _payload);
    setUnderwriteMeValidation(_payload);
  };

  const setApplicationPolicyPayload = (_payload) => {
    AppStorage.setItem(ApplicationPolicyPayload, _payload);
    setApplicationPayload(_payload);
  };

  const setDonationPayload = (_payload) => {
    AppStorage.setItem(DonationPayload, _payload);
    setDonation(_payload);
  };

  const setPolicyRefNoPayload = (_payload) => {
    AppStorage.setItem(PolicyRefNoPayload, _payload);
    setPolicyRefNo(_payload);
  };

  const setEPFCampaignCodePayload = (_payload) => {
    AppStorage.setItem(EPFCampaignCodePayload, _payload);
    setEPFCampaignCode(_payload);
  };

  const removeDocumentUploadedPayload = () => {
    AppStorage.setItem(DocumentUploadedPayload, []);
    setDocumentUploadedPayload([]);
  };

  const removePromoCodePayload = () => {
    setPromoCodePayload({});
  };
  const removepromoCodeSummaryPayload = () => {
    setPromoCodeSummary('');
  };
  const clearAllPayloads = () => {
    AppStorage.clear();
  };

  return (
    <PolicyPayloadContext.Provider
      value={{
        policyPayload,
        setPolicyPayload,
        clearPayload,
        paymentFrequency,
        setPaymentFrequency,
        originalPremiumPlanPayload,
        setOriginalPremiumPlan,
        multiQuotes,
        setMultiQuotes,
        isDocumentUploaded,
        setIsDocumentUploaded,
        documentUploadedPayload,
        setDocumentUploaded,
        promoCodePayload,
        setPromoCodePayload,
        removePromoCodePayload,
        promoCodeSummaryPayload,
        setPromoCodeSummary,
        removepromoCodeSummaryPayload,
        removeDocumentUploadedPayload,
        clearAllPayloads,
        deductiblePayload,
        setDeductiblePayload,
        underwriteMeStaticAnswersPayload,
        setUnderwriteMeStaticAnswersPayload,
        underwriteMeValidationPayload,
        setUnderwriteMeValidationPayload,
        applicationPolicyPayload,
        setApplicationPolicyPayload,
        donationPayload,
        setDonationPayload,
        policyRefNoPayload,
        setPolicyRefNoPayload,
        ePFCampaignCodePayload,
        setEPFCampaignCodePayload
      }}
    >
      {children}
    </PolicyPayloadContext.Provider>
  );
};

PolicyPayloadProvider.propTypes = {
  children: PropTypes.element
};

export default PolicyPayloadProvider;
